/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { SESSION_STORAGE_PENDING_PAYMENT } from "../constants/constants";

/**
 * Marks the invoice being paid in a popup so the return still resolves if this document reloads
 * meanwhile (Safari inside Wix's embed). DefaultRouteHandler consumes it on boot; activeFlow
 * isn't stored because flowSlice persists it. See docs/features/react_widget_payment_return.md.
 *
 * Guarded everywhere: an `<iframe srcdoc>` embed has origin "null", where sessionStorage throws.
 */

export const setPendingPayment = (params) => {
  if (!params || !params.invoiceId) return;
  try {
    sessionStorage.setItem(SESSION_STORAGE_PENDING_PAYMENT, JSON.stringify(params));
  } catch {
    // No storage - only the reload safety net is lost, the postMessage path still works.
  }
};

export const getPendingPayment = () => {
  try {
    const stored = sessionStorage.getItem(SESSION_STORAGE_PENDING_PAYMENT);
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    return parsed && typeof parsed === "object" && parsed.invoiceId ? parsed : null;
  } catch {
    return null;
  }
};

export const clearPendingPayment = () => {
  try {
    sessionStorage.removeItem(SESSION_STORAGE_PENDING_PAYMENT);
  } catch {
    // see setPendingPayment
  }
};
